import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Section,
  GodsContainer,
  Container,
  GodsContent,
  GodsSubTitle,
  GodsTitle,
  GradientText,
  Line,
  WorkContainer,
  StyledSwiper,
  SlideContent,
  GodImage,
} from "../styles/sections/GodsSectionStyles";

const gods = [
  {
    name: "Zeus",
    image:
      "https://framerusercontent.com/images/yB1vBoXcLzeu0PaS7K81qyeDgo.png",
    changeImage:
      "https://framerusercontent.com/images/f90FZ0owtJIwDIOs4wOU7gnVhi0.png",
  },
  {
    name: "Hades",
    image:
      "https://framerusercontent.com/images/71ahEHLxAXWcyCwyzxv5cJMCY8.png",
    changeImage:
      "https://framerusercontent.com/images/DoQXydsDNrXGC4JF5zVq3KBSg2M.png",
  },
  {
    name: "Aphrodite",
    image:
      "https://framerusercontent.com/images/0Cavfmsg0ojXy8CYzmZme31Qu4.png",
    changeImage:
      "https://framerusercontent.com/images/BxJJiYs5OVIDu03gzYfA8eZqbmE.png",
  },
  {
    name: "Dionysos",
    image:
      "https://framerusercontent.com/images/WalThVweLKpFZiQZcgUIXCw1Jo4.png",
    changeImage:
      "https://framerusercontent.com/images/D6Y90BRs6p28yKeyAj11kafmpA.png",
  },
  {
    name: "Hermes",
    image: "https://framerusercontent.com/images/HjcRACYYHaPnigtpdkYYlNKn4.png",
    changeImage:
      "https://framerusercontent.com/images/LrYS4VLLu391DtrTI3xAk1oXv8U.png",
  },
  {
    name: "Hestia",
    image:
      "https://framerusercontent.com/images/BoDb7YOzcQ2VFWHVL9EeKzZpzgs.png",
    changeImage:
      "https://framerusercontent.com/images/e8fobmn4SrJUtZzhlvSxeMwhVI.png",
  },
  {
    name: "Poseidon",
    image:
      "https://framerusercontent.com/images/kgFrslPrWIejtmYW5iz8ouRzHw.png",
    changeImage:
      "https://framerusercontent.com/images/LGw4MsCADvvwu0002v2AsTTPyFw.png",
  },
  {
    name: "Hera",
    image: "https://framerusercontent.com/images/kqdNV3aKK63wFnrWwr9LwE.png",
    changeImage:
      "https://framerusercontent.com/images/oVesSFmrFiYKDqeujnVSEQF1M.png",
  },
  {
    name: "Demeter",
    image:
      "https://framerusercontent.com/images/png4vgTUKKZ8zr8n1sLL1snczWg.png",
    changeImage:
      "https://framerusercontent.com/images/DikDUFOuxQd6E2ovZJO8SXF0bGk.png",
  },
  {
    name: "Apollo",
    image:
      "https://framerusercontent.com/images/LRIGXChKt6DjcNUma94KuWF9aY.png",
    changeImage:
      "https://framerusercontent.com/images/9pjIm9jmAImxV6OoXXokBcNPA.png",
  },
  {
    name: "Ares",
    image: "https://framerusercontent.com/images/CmAk3zJsUMl16V1g0RVP6Od4w.png",
    changeImage:
      "https://framerusercontent.com/images/Hy1tmoE7CifxXzFHHG1WqJ6gU6E.png",
  },
  {
    name: "Hephaestus",
    image: "https://framerusercontent.com/images/yWMr7KP4u6BMCKwV0BloNFQRY.png",
    changeImage:
      "https://framerusercontent.com/images/rxCfGzruiM5uuEqIPRz3wVzNHg.png",
  },
];

const GodsSection = () => {
  const [clickedIndex, setClickedIndex] = useState(null);

  const handleSlideChange = () => {
    setClickedIndex(null);
  };

  return (
    <Section id="gods">
      <GodsContainer>
        <Container>
          <GodsContent>
            <GodsSubTitle>Abilities of the Gods</GodsSubTitle>
            <GodsTitle
              as={motion.div}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <GradientText>GODS</GradientText>
            </GodsTitle>
          </GodsContent>
        </Container>
        <Line
          as={motion.div}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />
      </GodsContainer>
      <WorkContainer>
        <StyledSwiper
          modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
          spaceBetween={0}
          slidesPerView={3}
          centeredSlides={true}
          loop={true}
          loopedSlides={3}
          navigation
          pagination={{ clickable: true }}
          grabCursor={true}
          speed={800}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          onSlideChange={handleSlideChange}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          }}
        >
          {gods.map((god, index) => (
            <SwiperSlide key={index}>
              <SlideContent
                onClick={() =>
                  setClickedIndex(clickedIndex === index ? null : index)
                }
              >
                <GodImage
                  src={clickedIndex === index ? god.changeImage : god.image}
                  alt={god.name}
                />
              </SlideContent>
            </SwiperSlide>
          ))}
        </StyledSwiper>
      </WorkContainer>
    </Section>
  );
};

export default GodsSection;
